/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DtpContentContainer,
  DtpNoContent,
} from 'dtp-react-components';
import {
  Button,
  Table,
  DataGrid,
} from '../../../components/index';
import {
  trataMensagensErro,
  trataMensagemSucesso,
  validateObject,
  requestPeriodosVigencia,
  doPut,
} from '../../../utils/requests';
import { manterApenasFiltro, formatarCnpj } from '../../../utils/helpers';
import ModalCadastroPeriodos from './ModalCadastroPeriodos';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';

class CadastroPeriodos extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

getInitialState = () => ({
  periodo: {
    cnpj: null,
    dataCriacaoRpps: null,
    dataEncerramentoRpps: null,
  },
  validadeCampos: {
    dataCriacaoRpps: false,
    dataEncerramentoRpps: false,
  },
  cnpj: null,
  botaoIncluirDesabilitado: true,
  periodosVigencia: [],
  acao: 'novo',
  acaoModal: 'alterar',
  estadoFormulario: 'inicial',
  noContentPrimaryMessage: 'Período não encontrado.',
  noContentSecondaryMessage: 'Informe outro período.',
  showModal: false,
  errosPeriodoSelecionado: null,
  periodoSelecionado: null,
});

componentDidMount() {
  manterApenasFiltro('');
  this.montaFormulario();
}

buscarPeriodosVigenciaRegimesProprios = () => {
  requestPeriodosVigencia(this.handleErrorBusca, '99999');
}

montaFormulario = () => {
  this.setState(this.buscarPeriodosVigenciaRegimesProprios());
  const { acao } = { ...this.state };
  const { validadeCampos } = { ...this.state };
  const paramPeriodosVigencia = this.props.periodosVigencia;
  let paramBotaoIncluirDesabilitado = true;
  // let paramCnpj = '';
  if (paramPeriodosVigencia && paramPeriodosVigencia.length > 0) { 
    // paramCnpj = paramPeriodosVigencia[0].cnpj;
    paramPeriodosVigencia.forEach((aux) => {
      if (!aux.dataEncerramentoRpps) {
        paramBotaoIncluirDesabilitado = true;
      } else if ((acao !==  'criacao') &&
        aux.dataEncerramentoRpps !== null && aux.dataEncerramentoRpps !== null) {
        // habilitar o botao de inclusao
        paramBotaoIncluirDesabilitado = false;
      }
    });
    validadeCampos.dataEncerramentoRpps = false;
  } else {
    paramBotaoIncluirDesabilitado = false;
  }
  this.setState({
    botaoIncluirDesabilitado: paramBotaoIncluirDesabilitado,
    // cnpj: paramCnpj,
    validadeCampos: {
      ...validadeCampos,
    },
  });
}

montaValidadeCampos = (periodo) => {
  const { validadeCampos } = { ...this.state };
  Object.keys(periodo).forEach((key) => {
    validadeCampos[key] = true;
  });
  return validadeCampos;
}

formularioProntoParaEnvio = () => (
  validateObject(this.state.validadeCampos)
);

handleChange = (changeObj, name, callback = null) => {
  const { periodo } = { ...this.state };
  this.setState({
    periodo: {
      ...periodo,
      [name]: changeObj.value,
    },
    validadeCampos: {
      ...this.state.validadeCampos,
      [name]: changeObj.isValid,
    },
  }, callback);
}

validacaoErrosPeriodo = (errosPeriodos) => {
  let camposInvalidos = null;
  // if (isDelete) {
  //   camposInvalidos = errosOrgaoVinculado;
  // } else {
  camposInvalidos =
    this.state.camposOrgaosVinculadosInvalidos.filter(erro =>
      (errosPeriodos.includes(erro) ? null : erro));
  // }
  this.setState({ camposOrgaosVinculadosInvalidos: camposInvalidos });
}

handleChangePeriodos = (changeObj, name) => {
  const { periodo } = { ...this.state };
  // let desabilitar = true;
  let validadeCampos;
  // if (periodo) {
  //   if (periodo.dataCriacaoRpps !== '' && periodo.dataEncerramentoRpps !== '') {
  //     desabilitar = false;
  //     validadeCampos = this.montaValidadeCampos(periodo);
  //   }
  // }
  let paramAcao ='';
  if(changeObj[0].flagOperacao === 2){
    paramAcao = 'edicao';
  } else {
    paramAcao = 'criacao';
  }
  this.setState({
    periodo: {
      ...periodo,
      [name]: changeObj,
    },
    cnpj: changeObj[0].cnpj,
    botaoIncluirDesabilitado: true,
    acao: paramAcao,
    validadeCampos: {
      ...validadeCampos,
    },
  });
}

alteraListaPeriodos = (listaPeriodos, errosPeriodos) => {
  if (errosPeriodos) {
    this.validacaoErrosOrgaoVinculado(errosPeriodos, true);
  }
  this.handleChangePeriodos(listaPeriodos, 'periodosVigencia');
}

addPeriodo = (periodo, edit) => {
  const { periodosVigencia } = { ...this.props };
  if((edit) && edit.cnpj == null &&
    edit.dataCriacaoRpps == null &&
    edit.dataEncerramentoRpps== null ){
      edit = null;
  }
  if (edit) {
    const periodoVigencia = { ...periodo };
    if (periodoVigencia.dataEncerramentoRpps !== '') {
      periodoVigencia.flagOperacao = 2;
    }
    periodosVigencia[this.state.cell] = periodoVigencia;
  } else {
    const periodoInclusao = periodo;
    periodoInclusao.flagOperacao = 1;
    if (periodosVigencia && periodosVigencia.length > 0) {
      periodoInclusao.cnpj = periodosVigencia[0].cnpj;
    }
    periodosVigencia.unshift(periodoInclusao);
  }
  this.alteraListaPeriodos(periodosVigencia, null);
}

trataSucesso = () => {
  const { acao } = { ...this.state }
  let mensagemSucesso = 'Período criado.';
  if (acao !== 'criacao') {
    mensagemSucesso = 'Período alterado.';
  }
  this.montaFormulario();
  this.setState({
    estadoFormulario: 'criado',
  });
  trataMensagemSucesso([mensagemSucesso]);
}

trataSucessoResponseEnvio = () => {
  this.trataSucesso();
}

incluirPeriodo = () => {
  let { cnpj } = { ...this.state };
  if (this.props.periodosVigencia && this.props.periodosVigencia.length > 0) {
    cnpj = this.props.periodosVigencia[0].cnpj;
  }
  this.setState({
    acaoModal: 'criacao',
    cnpj,
  }, this.handleModal);
}

createCustomInsertButton = () => (
  <React.Fragment>
    {(this.props.auth.checkPermission(['analisar-negocio-sprev'])) ?
      <Button
        disabled={this.state.botaoIncluirDesabilitado}
        hint="Adicionar Período"
        icon="ico-user-plus"
        onClick={() => this.incluirPeriodo()}
      />
    : ''}
  </React.Fragment>
);

handleModal = () => {
  this.setState({
    showModal: !this.state.showModal,
    acaoModal: this.state.acaoModal
   });
}

editPeriodo = (indice, periodo) => {
  let errosPeriodoSelecionado = null;
  if (this.errosPeriodo) {
    errosPeriodoSelecionado = this.errosPeriodo
      .filter(erro => erro.indiceLista === indice);
  }
  this.setState({
    cell: indice,
    acaoModal: 'edicao',
    periodo,
    errosPeriodoSelecionado,
  }, this.handleModal);
}

createActionColumn = (indice, periodo) => (
  <React.Fragment>
    {(this.props.auth.checkPermission(['analisar-negocio-sprev'])) && (!periodo.periodoFinalizado) ?
      <Button
        hint="Alterar Período"
        icon="ico-doc-pencil"
        mini
        onClick={() => this.editPeriodo(indice, periodo)}
      />
    : ''}
  </React.Fragment>
);

options = {
  hideSizePerPage: true,
  insertBtn: this.createCustomInsertButton,
  noDataText: 'Nenhum período adicionado à lista',
  sizePerPage: 10,
};

montaTableHeader = () => {
  const tableHeader = [{
    id: 'cnpj',
    label: 'CNPJ',
  }, {
    id: 'dataCriacaoRpps',
    label: 'Data de Criação',
  }, {
    id: 'dataEncerramentoRpps',
    label: 'Data de Encerramento',
  }];
  if (this.props.auth.checkPermission(['analisar-negocio-sprev'])) {
    tableHeader.push({
      id: 'acoes',
      label: 'Ações',
      dataFormat: this.createActionColumn,
    });
  }
  return tableHeader;
}

resetPeriodoSelecionado = () => {
  this.setState({
    periodo: null,
    acaoModal: null,
    errosPeriodoSelecionado: null,
  });
}

/**
* Trata o click do botao de submissao do formulario
* Se analise estiver indeferindo, exibir alerta de confirmacao
*/
handleSaveButton = () => {
  this.confirmSendData();
}
/**
* Trata envio dos dados
*/
confirmSendData = () => {
  const touched = true;
  const url = 'regimes-proprios';

  const { validadeCampos } = { ...this.state };
  Object.keys(validadeCampos).forEach((key) => {
    validadeCampos[key] = true;
  });

  this.setState({
    touched,
    validadeCampos,
    requestPesquisa: null,
  }, () => this.handleSave(url));
}

handleSave = (url) => {
  if (this.formularioProntoParaEnvio()) {
    // let { periodosVigencia } = { ...this.state };
    let listaPeriodosVigencia = this.props.periodosVigencia;

    if (listaPeriodosVigencia &&
      listaPeriodosVigencia.length > 0) {
      const colecao = [];
      listaPeriodosVigencia.forEach((periodo) => {
        if (periodo.flagOperacao) {
          colecao.push(periodo);
        }
      });
      if (colecao.length > 0) {
        listaPeriodosVigencia = colecao;
      } else {
        // não alterou e nem incluiu orgao vinculado
        const listaAux = [];
        listaPeriodosVigencia.map((item, i) => {
          const itemIndexado = item;
          itemIndexado.contador = i;

          if (i <= 5) {
            listaAux.push(itemIndexado);
          }
          return listaAux;
        });
        listaPeriodosVigencia = [];
        listaPeriodosVigencia = listaAux;
      }
    }
    doPut(
      url,
      { periodosVigencia: listaPeriodosVigencia },
      this.trataSucesso,
    );
  } else {
    trataMensagensErro(['Informe corretamente os atributos indicados na tela.']);
  }
}

render() {
  if (this.state.reset) {
    return null;
  }

  if (this.state.showNoContent) {
    return (
      <DtpNoContent
        primaryText={this.state.noContentPrimaryMessage}
        secondaryText={this.state.noContentSecondaryMessage}
        show={this.state.showNoContent}
      />);
  }

  const listaPeriodosIndexada =
      this.props.periodosVigencia.map((item, i) => {
        const itemIndexado = item;
        itemIndexado.acoes = i;
        itemIndexado.cnpj = formatarCnpj(itemIndexado.cnpj);
        return itemIndexado;
      });

  let botaoAcaoPrincipal;
  const configBotaoPrincipal = {
    onClick: this.handleSaveButton,
  };
  configBotaoPrincipal.permissoes = ['analisar-negocio-sprev'];
  configBotaoPrincipal.titulo = 'Salvar';
  configBotaoPrincipal.hint = 'Salvar Período';
  const botaoAcaoVoltar = (
    <Button
      className="left"
      onClick={this.props.history.goBack}
      title="Voltar"
      hint="Voltar para tela anterior"
    />
  );

  if (configBotaoPrincipal.titulo) {
    botaoAcaoPrincipal = (
      <ProtectedItem allowedPermissions={configBotaoPrincipal.permissoes}>
        <Button
          className="dtp-primary right"
          disabled={!this.formularioProntoParaEnvio()}
          title={configBotaoPrincipal.titulo}
          onClick={configBotaoPrincipal.onClick}
          hint={configBotaoPrincipal.hint}
        />
      </ProtectedItem>
    );
  }

  return (
    <DtpContentContainer>
      <DataGrid title="Periodos RPPS da União" icon="ico-doc-book" >
        <Table
          bordered
          insertRow="true"
          data={listaPeriodosIndexada}
          options={this.options}
          listaTableHeader={this.montaTableHeader()}
          pagination
          fetchInfo={this.fetchInfo}
        />
        {this.state.showModal ? (
          <ModalCadastroPeriodos
            auth={this.props.auth}
            acao={this.state.acao}
            acaoModal={this.state.acaoModal}
            periodo={this.state.periodo}
            cnpj={this.state.cnpj}
            habilitarCampoCpf={this.props.periodosVigencia.length === 0}
            showModal={this.state.showModal}
            handleModal={() => this.handleModal('showModal')}
            handleChange={this.handleChange}
            addPeriodo={this.addPeriodo}
            onHide={this.handleModal}
            errosPeriodo={this.state.errosPeriodoSelecionado}
            validacaoErrosPeriodo={this.validacaoErrosPeriodo}
            resetPeriodo={this.resetPeriodoSelecionado}
          />
        ) : ''}
      </DataGrid>
      <div className="row">
        { botaoAcaoVoltar }
        { botaoAcaoPrincipal }
      </div>
    </DtpContentContainer>
  );
}
}

CadastroPeriodos.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      acao: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    goBack: PropTypes.function,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }),
  periodosVigencia: PropTypes.arrayOf(PropTypes.shape({
    cnpj: PropTypes.string,
    dataCriacaoRpps: PropTypes.string,
    dataEncerramentoRpps: PropTypes.string,
  })),
};

CadastroPeriodos.defaultProps = {
  match: null,
  auth: null,
  periodosVigencia: [],
};

const mapStateToProps = state => ({
  periodosVigencia: state.base.periodosVigencia,
});

export default connect(mapStateToProps)(CadastroPeriodos);



// WEBPACK FOOTER //
// ./src/pages/cadastros/PeriodosRppsUniao/CadastroPeriodos.jsx